// extracted by mini-css-extract-plugin
module.exports = {"news_display_box":"news_display_box-8_wzNGWf","top_news":"top_news-27zCjiQX","top_news_title":"top_news_title-2d4SdbpA","top_news_item":"top_news_item-dPvl7ioU"};